var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item-group',_vm._b({},'el-menu-item-group',_vm.trimAttrs(_vm.$attrs),false),[_c('template',{slot:"title"},[_vm._t("title")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }